import React, { useState } from "react";
import styled from "styled-components";
// import RightNav from "./RightNav";
import MobileDrawer from "./mobileDrawer";

const StyledBurger = styled.div`
  width: 2rem;
  height: 2rem;
  position: fixed;
  // top: 15px;
  // right: 20px;
  z-index: 91;
  display: none;
  transition: all 0.3s linear;
  transform: ${({ open }) => (open ? "translateX(calc(100vw - 170px))" : "translateX(0)")};

  @media (max-width: 500px) {
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
    // margin-right: 0px;
    // margin-top: 10px;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${({ open }) => (open ? "#ccc" : "#333")};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;

    &:nth-child(1) {
      transition-delay: 0.2s;
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }

    &:nth-child(2) {
      transition-delay: 0.2s;
      transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }

    &:nth-child(3) {
      transition-delay: 0.2s;
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
`;

const MobileBurger = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <StyledBurger open={open} onClick={() => setOpen(!open)}>
        <div />
        <div />
        <div />
      </StyledBurger>
      <MobileDrawer open={open} setOpen={setOpen} />
    </>
  );
};

export default MobileBurger;
